import React from 'react';
import './Loading.css';
interface ILoadingProps {
  isLoading?: boolean;
}

const Loading = ({ isLoading }: ILoadingProps) => {
  const isReallyLoading = !!isLoading ? 'active' : '';

  return (
    <div className={`loading ${isReallyLoading}`}>
      <div className="loader">
        <span className="dot dot-1"></span>
        <span className="dot dot-2"></span>
        <span className="dot dot-3"></span>
        <span className="dot dot-4"></span>
      </div>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.tsx